<template>
    <div>
        <div class="content-wrapper" v-if="!loadingComplete()">
            <section class="content">
                <div class="col-md-12">
                    <div class="box box-primary">
                        <div class="box-header">
                            <h3 class="box-title">Chargement en cours</h3>
                        </div>
                        <div class="box-body">
                            Chargement de la fiche du club
                        </div>
                        <div class="overlay">
                            <i class="fa fa-refresh fa-spin"></i>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="content-wrapper" v-if="loadingComplete()">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <h1>
                    {{this.getClub.numero_club }} - {{this.getClub.club }}
                    <small>Fiche club</small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li><a href="#">Club</a></li>
                    <li class="active">{{this.getClub.numero_club }} - {{this.getClub.club }}</li>
                </ol>
            </section>
            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="nav-tabs-custom nav-tabs-custom-bottom">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="active">
                                    <a href="#member_tab_1"
                                       aria-controls="#member_tab_1"
                                       data-toggle="tab"
                                       aria-expanded="false">Fiche
                                        administrative</a>
                                </li>
                                <li class="">
                                    <a href="#member_tab_2"
                                       aria-controls="#member_tab_2"
                                       data-toggle="tab"
                                       aria-expanded="false">Licences</a>
                                </li>
                                <li class="">
                                    <a href="#member_tab_3"
                                       aria-controls="#member_tab_3"
                                       data-toggle="tab"
                                       aria-expanded="false">Listing membre</a>
                                </li>
                                <li class="">
                                    <a href="#member_tab_31"
                                       aria-controls="#member_tab_31"
                                       data-toggle="tab"
                                       aria-expanded="false">Récapitulatifs</a>
                                </li>
                                <li class="">
                                    <a href="#member_tab_4"
                                       aria-controls="#member_tab_4"
                                       data-toggle="tab"
                                       aria-expanded="false">MyABFT</a>
                                </li>
                                <li class="" >
                                    <a href="#member_tab_5"
                                       aria-controls="#member_tab_5"
                                       data-toggle="tab"
                                       aria-expanded="false">Statistiques</a>
                                </li>
                                <li class="" v-if="getProcessEnv.NODE_ENV=='development'">
                                    <a href="#member_tab_6"
                                       aria-controls="#member_tab_6"
                                       data-toggle="tab"
                                       aria-expanded="false">Historique</a>
                                </li>
                                <li class="">
                                    <a href="#member_tab_7"
                                       aria-controls="#member_tab_7"
                                       data-toggle="tab"
                                       aria-expanded="false">Labelisation</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row tab-content">
                    <div role="tabpanel" class="col-md-12 tab-pane active" id="member_tab_1">
                        <MainFormClub></MainFormClub>
                    </div>

                    <div role="tabpanel" class="col-md-12 tab-pane" id="member_tab_2">
                        <FormLicenceClub></FormLicenceClub>
                    </div>

                    <div role="tabpanel" class="col-md-12 tab-pane" id="member_tab_3">
                        <ListingMembres></ListingMembres>
                    </div>
                    <div role="tabpanel" class="col-md-12 tab-pane" id="member_tab_31">
                        <ListingRecapitulatif></ListingRecapitulatif>
                    </div>
                    <div role="tabpanel" class="col-md-12 tab-pane" id="member_tab_4">
                        <MyABFTClub></MyABFTClub>
                    </div>
                    <div role="tabpanel" class="col-md-12 tab-pane" id="member_tab_5">
                      <StatistiquesClub></StatistiquesClub>
                    </div>
                    <div role="tabpanel" class="col-md-12 tab-pane" id="member_tab_6">
                    </div>
                    <div role="tabpanel" class="col-md-12 tab-pane" id="member_tab_7">
                        <LabelisationClub :club-id="club_id"></LabelisationClub>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MainFormClub from './MainFormClub.vue'
    import FormLicenceClub from './FormLicenceClub.vue'
    import ListingMembres from './ListingMembres.vue'
    import ListingRecapitulatif from './ListingRecapitulatifs.vue'
    import MyABFTClub from './MyABFTClub.vue'
    import StatistiquesClub from './Statistiques.vue'
    import LabelisationClub from './LabelisationClub.vue'
    import ListingRecap from "../Recapitulatif/ListingRecap";

    export default {
        data() {
            return {}
        },
        props: {
            club_id: {
                required: true
            }
        },
        mounted: function () {
            this.$nextTick(function () {
                this.loadPays()
                this.loadProvinces()
                this.loadVilles()
                this.loadPostes()
                this.loadProfessions()
                this.loadTypesLicences()
                this.loadStatutsSportifs()
                this.loadClub()
            })
        },
        computed: {

            ...mapGetters({
                getProcessEnv:"getProcessEnv",
                getClub: 'getClub',
                getProfessions: 'getProfessions',
                getProvinces: 'getProvinces',
                getPays: 'getPays',
                getVilles: 'getVilles',
                getRoute: 'getRoute',
                getTypesLicences: 'getTypesLicences',
                getStatutsSportifs: 'getStatutsSportifs',
            })
        },
        methods: {
            ...mapActions({
                setProfessions: 'setProfessions',
                setPays: 'setPays',
                setProvinces: 'setProvinces',
                setPostes: 'setPostes',
                setVilles: 'setVilles',
                setClub: 'setClub',
                setTypesLicences: 'setTypesLicences',
                setStatutsSportifs: 'setStatutsSportifs',
            }),
            loadingComplete: function () {
                return this.getClub != null &&
                    this.getPays != null &&
                    this.getVilles != null &&
                    this.getProfessions != null
            },
            loadClub: function () {
                this.setClub(null)
                this.$http.get(this.getRoute('getInfosClub') + this.club_id)
                    .then((response) => {
                        this.setClub(response.body)
                    }, (response) => {
                        this.setClub(null)
                    });
            },
            loadTypesLicences: function () {
                this.$http.get(this.getRoute('getAllTypesLicences')).then((response) => {
                    this.setTypesLicences(response.body)
                }, (response) => {
                });
            },
            loadStatutsSportifs: function () {
                this.$http.get(this.getRoute('getAllStatutsSportifs')).then((response) => {
                    this.setStatutsSportifs(response.body)
                }, (response) => {
                });
            },
            loadPays: function () {
                this.$http.get(this.getRoute('getAllPays')).then((response) => {
                    this.setPays(response.body)
                }, (response) => {
                });
            },
            loadProvinces: function () {
                this.$http.get(this.getRoute('getAllProvinces')).then((response) => {
                    this.setProvinces(response.body)
                }, (response) => {
                });
            },
            loadVilles: function () {
                this.$http.get(this.getRoute('getAllVilles')).then((response) => {
                    this.setVilles(response.body)
                }, (response) => {
                });
            },
            loadPostes: function () {
                this.$http.get(this.getRoute('getPostesForClub')).then((response) => {
                    this.setPostes(response.body)
                }, (response) => {
                });
            },
            loadProfessions: function () {
                this.$http.get(this.getRoute('getAllProfessions')).then((response) => {
                    this.setProfessions(response.body)
                }, (response) => {
                });
            },
        },
        watch: {
            '$route':function() {
                // console.log("Route has changed")
                this.setClub(null)
                this.loadClub()
            }
        },
        components: {
            ListingRecapitulatif,
            MainFormClub,
            FormLicenceClub,
            ListingMembres,
            StatistiquesClub,
            MyABFTClub,
            LabelisationClub,
            // ListingCompetitions,
            // ListingStageExamensFormations,
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Club/AppClub.vue